"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toca_shared_utils_1 = require("toca-shared-utils");
var _1 = require(".");
function ConfigureAmplify(amplify) {
    var _a;
    var cognitoConfigIdentifier = _1.BrandConfiguration.getCognitoConfigIdentifier();
    var cognitoConfig = (_a = _1.AuthConfig.authConfiguration.find(function (x) { return x.cognitoConfigIdentifier === cognitoConfigIdentifier; })) === null || _a === void 0 ? void 0 : _a.cognitoConfig;
    if (cognitoConfig === undefined) {
        console.log("Cognito Config cannot be found for " + cognitoConfigIdentifier);
        return;
    }
    amplify.configure({
        Auth: {
            // REQUIRED - Amazon Cognito Region
            region: cognitoConfig.cognitoRegion,
            // OPTIONAL - Amazon Cognito Federated Identity Pool Region
            // Required only if it's different from Amazon Cognito Region
            identityPoolRegion: cognitoConfig.cognitoRegion,
            // OPTIONAL - Amazon Cognito User Pool ID
            userPoolId: cognitoConfig.cognitoUserPoolId,
            // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
            userPoolWebClientId: cognitoConfig.cognitoUserPoolWebClientId,
            // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
            mandatorySignIn: true,
            // The USER_PASSWORD_AUTH flow will send user credentials unencrypted to the back-end.
            // If you want to migrate users to Cognito using the "Migration" trigger
            // and avoid forcing users to reset their passwords,
            // you will need to use this authentication type
            // because the Lambda function invoked by the trigger needs to verify the supplied credentials
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            cookieStorage: {
                // REQUIRED - Cookie domain (only required if cookieStorage is provided)
                // domain: cookieDomain,
                domain: toca_shared_utils_1.CookieUtils.getCookieDomain(),
                // OPTIONAL - Cookie path
                path: '/',
                // OPTIONAL - Cookie expiration in days
                //expires: 365,
                // OPTIONAL - Cookie secure flag
                // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
                secure: false,
            },
        },
        Analytics: {
            disabled: true,
        },
    });
}
exports.default = ConfigureAmplify;
//# sourceMappingURL=AwsConfig.js.map